import { createFileRoute } from '@tanstack/react-router';

import { PhoneSetupInstructionsPanel } from '@apps/web/components/settings/phone_setup/phone_setup_instructions_panel';
import { PhoneSetupPageShell } from '@apps/web/components/settings/phone_setup/phone_setup_page_shell';
import {
    renderPhoneSetupRouteGuard,
    usePhoneSetupRoute,
} from '@apps/web/components/settings/phone_setup/use_phone_setup_route';

export const Route = createFileRoute('/_app/settings/phone-instructions')({
    component: PhoneInstructionsSettingsPage,
});

function PhoneInstructionsSettingsPage() {
    const routeState = usePhoneSetupRoute();

    return renderPhoneSetupRouteGuard(
        routeState,
        (ready) => (
            <PhoneSetupPageShell title="Phone setup">
                <PhoneSetupInstructionsPanel
                    organizationId={ready.organizationId}
                />
            </PhoneSetupPageShell>
        ),
        { requiresPhoneSetupVisible: true },
    );
}
